/**
 * Formats ISO date string to readable format
 * @param isoDate - ISO date string (e.g., "2025-09-20T13:10:18")
 * @returns Formatted date string (e.g., "Sep 20, 2025")
 */
export const formatDate = (isoDate: string): string => {
  try {
    const date = new Date(isoDate);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  } catch (error) {
    return isoDate;
  }
};

/**
 * Gets the initial letter from a name
 * @param name - First name or full name
 * @returns First letter in uppercase
 */
export const getInitial = (name: string): string => {
  return name.charAt(0).toUpperCase();
};

/**
 * Combines first and last name
 * @param firstName - First name
 * @param lastName - Last name
 * @returns Full name
 */
export const getFullName = (firstName: string, lastName: string): string => {
  return `${firstName}${lastName ? ' ' + lastName : ''}`.trim();
};
